import MedicalReportGraphDialog from "./medical-report-editor-dialog";
export default MedicalReportGraphDialog;
